import log from 'loglevel';

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  log.setLevel('trace')
} else {
  log.setLevel('error')
}

export default log;
